import * as React from 'react';

import AssetEventSummary from './AssetEventSummary';
import EventsSecurityLicenseStatus from './EventsSecurityLicenseStatus';

type AssetEventSummaryContainerProps = {
  config: any;
};

const AssetEventSummaryContainer: React.FC<AssetEventSummaryContainerProps> = ({ config }) => (
  <EventsSecurityLicenseStatus>
    <AssetEventSummary config={config} />
  </EventsSecurityLicenseStatus>
);

export default AssetEventSummaryContainer;
